import { Capacity, type CapacityProps } from './Capacity';
import { Summary, type SummaryProps } from './Summary';

export interface DetailProps extends CapacityProps, SummaryProps {}
/**
 * Detail component combines vehicle information and capacity details
 *
 * @param capacityData - Array of capacity items (passengers, luggage)
 * @param vehicleType - Type of vehicle (e.g., "SUV", "Hatchback")
 * @param model - Vehicle model description (e.g., "Creta or similar")
 * @param pricing - Pricing information with original and optional discounted price
 */
export const Detail = ({
	capacityData,
	vehicleType,
	model,
	pricing,
	burnOpted,
	children,
}: DetailProps) => {
	return (
		<div className="w-full flex flex-col gap-y-0.5">
			<Summary
				vehicleType={vehicleType}
				model={model}
				pricing={pricing}
				burnOpted={burnOpted}
			>
				{children}
			</Summary>
			<Capacity capacityData={capacityData} />
		</div>
	);
};
